import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import swal from 'sweetalert2';
import { flagMessage } from 'actions/conversation';
import { getReaderParameters } from 'actions/user';
import { trackImmersiveReaderError } from 'helpers/insights';
import { Spinner } from 'UI';
import Message from './Partials/Message';
import { getActiveLanguage, translate } from '@haldor/ui';
var ImmersiveReader = require('@microsoft/immersive-reader-sdk');
var ConversationMessages = /*#__PURE__*/function (_Component) {
  /* Class setup */
  function ConversationMessages(props) {
    var _this;
    _classCallCheck(this, ConversationMessages);
    _this = _callSuper(this, ConversationMessages, [props]);
    _defineProperty(_this, "setContainer", function (element) {
      _this.container = element;
    });
    /* Lifecycle methods */
    _defineProperty(_this, "componentWillUnmount", function () {
      _this.container.removeEventListener('scroll', _this.onScroll);
    });
    _defineProperty(_this, "componentDidMount", function () {
      // Get messages (page 1)
      var conversation = _this.props.conversation;
      if (_this.container != null) {
        _this.container.scrollTop = _this.container.scrollHeight;
        _this.container.addEventListener('scroll', _this.onScroll);
      }
    });
    _defineProperty(_this, "componentDidUpdate", function (prevProps, prevState) {
      if (prevState != _this.state) {
        return;
      }
      _this.container.scrollTop = _this.container.scrollHeight;
    });
    /* Helper methods */
    _defineProperty(_this, "throttle", function (func, immediate) {
      return function () {
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        var later = function later() {
          this.timeout = null;
          if (!immediate) func.apply(this, args);
        };
        var callNow = immediate && !_this.timeout;
        clearTimeout(_this.timeout);
        _this.timeout = setTimeout(later, _this.scrollLimit);
        if (callNow) func.apply(_this, args);
      };
    });
    _defineProperty(_this, "loadMore", function () {
      var onScrollComplete = _this.throttle(function () {
        if (!_this.state.loadingMore) {
          _this.setState({
            loadingMore: true
          });
          console.log('load next page');
        }
      });
      onScrollComplete();
    });
    _defineProperty(_this, "getUserById", function (id) {
      if (_this.props.conversation != null) {
        var membership = _this.props.conversation.memberships.find(function (membership) {
          return membership.membershipID == id;
        });
        if (membership != null) {
          return _objectSpread({
            id: membership.membershipID
          }, membership.user);
        }
      }
      return false;
    });
    /* Events */
    _defineProperty(_this, "getMessages", function () {});
    _defineProperty(_this, "onScroll", function (event) {
      if (_this.container.scrollTop < 10) {
        _this.loadMore();
      }
    });
    _defineProperty(_this, "reportMessage", function (message) {
      var translate = _this.props.translate;
      swal({
        title: translate('Report message as inappropriate'),
        text: translate('Why do you want to report this message?'),
        input: 'text',
        showCancelButton: true,
        cancelButtonText: translate('Cancel'),
        confirmButtonText: translate('Report message')
      }).then(function (response) {
        if (response.value != null) {
          // Make request here or something
          _this.props.flagMessage(message.id, response.value).then(function () {
            swal({
              title: translate('The message has been reported'),
              text: translate('The message will be hidden while waiting for an administrator to manage the report.'),
              showCancelButton: false,
              confirmButtonText: translate('Okay')
            });
          });
        }
      });
    });
    _defineProperty(_this, "runImmersiveReader", /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(message) {
        var user, creator, name, owner_section, _owner_section$sectio, time, data, reader;
        return _regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              user = _this.props.user;
              creator = _this.getUserById(message.creator);
              name = '';
              if (message.senderId != null && message.senderType == 'SECTION') {
                owner_section = _this.props.conversation.memberships.find(function (m) {
                  return m.membershipID == message.senderId;
                });
                if (owner_section != null) {
                  name = (_owner_section$sectio = owner_section.section) === null || _owner_section$sectio === void 0 ? void 0 : _owner_section$sectio.title;
                }
              } else {
                name = creator.firstName + ' ' + creator.lastName;
              }
              time = moment(message.created).format("YYYY-MM-DD HH:mm");
              data = {
                title: name,
                chunks: [{
                  content: name + ', ' + time + '<br /><br />',
                  mimeType: 'text/html'
                }, {
                  content: message.text,
                  mimeType: 'text/html'
                }]
              };
              _context.next = 1;
              return _this.props.getReaderParameters();
            case 1:
              reader = _this.props.reader;
              if (!(reader == null)) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return");
            case 2:
              ImmersiveReader.launchAsync(reader.token, reader.subdomain, data, {
                uiLang: getActiveLanguage(),
                uiZIndex: 9147483
              })["catch"](function (error) {
                console.error('error', error);
                trackImmersiveReaderError(error, user.id);
              });
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    /* Render methods */
    _defineProperty(_this, "renderMessage", function (message, index) {
      var user = _this.props.user;
      var me = false;
      var narrow = false;
      var up = false;
      var down = false;
      var newMessage = false;
      var actions = [];
      var flagged = null;
      if (message.creator == user.id) {
        me = true;
        if (message.flagID != null) {
          flagged = _this.props.translate('Message is reported as inappropriate.');
        }
      } else {
        if (message.flagID == null) {
          actions.push({
            label: _this.props.translate('Report message'),
            onClick: function onClick() {
              return _this.reportMessage(message);
            }
          });
          actions.push({
            label: _this.props.translate('Immersive Reader'),
            onClick: function onClick() {
              return _this.runImmersiveReader(message);
            }
          });
        } else {
          flagged = _this.props.translate('Message is reported as inappropriate.');
        }
      }
      if (moment(message.created) > moment(_this.props.conversation.lastRead)) {
        newMessage = true;
      }
      var lastMessage = _this.props.conversation.messages[index - 1];
      if (lastMessage != null && lastMessage.creator == message.creator) {
        narrow = true;
        up = true;
      }
      var sender = '';
      var creator = _this.getUserById(message.creator);
      var nextMessage = _this.props.conversation.messages[index + 1];
      if (nextMessage != null) {
        if (nextMessage.creator == message.creator) {
          down = true;
        }
      }
      if (message.senderId != null && message.senderType == 'SECTION') {
        var owner_section = _this.props.conversation.memberships.find(function (m) {
          return m.membershipID == message.senderId;
        });
        if (owner_section != null) {
          var _owner_section$sectio2;
          sender = (_owner_section$sectio2 = owner_section.section) === null || _owner_section$sectio2 === void 0 ? void 0 : _owner_section$sectio2.title;
        }
      } else {
        sender = creator.firstName;
        if (creator.lastName != null) {
          sender += ' ' + creator.lastName;
        }
      }
      return /*#__PURE__*/React.createElement(Message, {
        key: message.id,
        children: message.text,
        time: message.created,
        multipleUp: up,
        actions: actions,
        multipleDown: down,
        narrow: narrow,
        sender: sender,
        me: me,
        "new": newMessage,
        flagged: flagged
      });
    });
    _this.state = {
      loadingMore: false,
      loading: true
    };
    _this.container = null;
    _this.event = null;
    _this.scrollLimit = 35;
    _this.timeout = null;
    return _this;
  }
  _inherits(ConversationMessages, _Component);
  return _createClass(ConversationMessages, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", {
        className: "conversation messages-container",
        ref: this.setContainer
      }, /*#__PURE__*/React.createElement("div", {
        className: "__inner"
      }, this.props.conversation != null ? this.props.conversation.messages.map(this.renderMessage) : /*#__PURE__*/React.createElement(Spinner, {
        center: true
      })));
    }
  }]);
}(Component);
function mapStateToProps(state) {
  return {
    messages: state.Conversation.messages,
    user: state.User.user,
    reader: state.User.reader,
    translate: translate(state.Languages.translations)
  };
}
export default connect(mapStateToProps, {
  flagMessage: flagMessage,
  getReaderParameters: getReaderParameters
})(ConversationMessages);